import { OnboardingRulesProgressResponse } from "@ifgengineering/client-invest-sdk";
import { RootState } from "../rootReducer";

export const dealAnchoredProgressSelector = (
  state: RootState
): OnboardingRulesProgressResponse | null => state.dealAnchoredProgress.data;

export const neverLoadedDealAnchoredProgressSelector = (
  state: RootState
): boolean => state.dealAnchoredProgress.neverLoaded;
